import * as ActionTypes from '../actions/Actiontype';

const initState = {
  error: '',
  isLoggedIn: '',
};

const store = (state = initState, action) => {
  switch (action.type) {
    case ActionTypes.LOGIN_INIT:
      return {
        ...state,
        error: '',
      };
    case ActionTypes.LOGIN_SUCCESS:
      return {
        ...state,
        isLoggedIn: true,
      };
    case ActionTypes.LOGIN_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default store;
